<template>
    <div style=" text-align: left;  color: black; margin-top: 40px;">
        <b class="ml-1">{{value}} </b>
    </div>
</template>

<script>
export default {
    name: 'HearderModel',
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>